var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLimitIcon = function SvgLimitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#limit-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#42526E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.143 6.2 8.44 5.094v.854c0 .139-.063.232-.188.28L6.143 7.275v.919L8.44 7.08v.853c0 .143-.063.239-.188.287L6.143 9.262v1.843h.763c.366 0 .696-.048.992-.143.301-.1.558-.24.77-.417a1.82 1.82 0 0 0 .5-.664c.12-.261.18-.554.18-.88 0-.082.035-.15.104-.202a.393.393 0 0 1 .23-.078h.818v.313c0 .495-.08.938-.243 1.329a2.597 2.597 0 0 1-.694.983 3.174 3.174 0 0 1-1.13.612 5.113 5.113 0 0 1-1.527.209H4.797V9.835l-1.297.619v-.867c0-.117.058-.204.173-.26l1.124-.554v-.931L3.5 8.46v-.867c0-.121.058-.206.173-.254l1.124-.553V2.833h1.346v3.368Z",
    fill: "#F4F5F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "limit-icon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#fff"
  })))));
};
export default SvgLimitIcon;